const actSchemaMapper = (restSchema) => {
  return {
    entityBundle: "participant",
    label: restSchema.title,
    id: restSchema.nid,
    title: restSchema.title,
    created: restSchema.created,
    path: {
      alias: restSchema.url,
    },
    url: {
      path: restSchema.url,
    },
    uri: {
      path: restSchema.url,
    },
    fieldCountry: {
      list: restSchema.country !== null ? restSchema.country.map(value => ({ value })) : [],
    },
    fieldCompany: restSchema.company,
    fieldPosition: restSchema.position,
    fieldTitleSort: restSchema.title_sort,
    fieldImage: {
      fieldCredits: restSchema.image_credits,
      fieldMediaImage: {
        alt: restSchema.image_alt,
        title: restSchema.image_title,
        entity: {
          filemime: restSchema.image_filemime,
          uri: ""
        },
        style: {
          url: restSchema.image_url,
          width: restSchema.image_width,
          height: restSchema.image_height,
        }
      }
    },
    fieldAppearances: restSchema.appearances.map(a => ({
      status: true,
      fieldPlanned: a.planned,
      fieldFake: a.fake,
      fieldShowcase: a.showcase,
      fieldHappening: {
        status: true,
        label: a.happening_title,
        url: {
          path: "#"
        }
      },
      fieldDateRawField: {
        first: {
          value: a.date_start * 1000,
          endValue: a.date_end * 1000,
        }
      },
      fieldVenue: {
        title: a.venue_location_name,
        url: {
          path: "#"
        }
      },
      fieldVenueLocation: {
        label: a.venue_location_name,
        id: a.venue_location_id,
        url: {
          path: "#",
        }
      },
    }))
  };
};

export default actSchemaMapper;